import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { UserModel, UserRolesModel } from '../../Models/userModel';
import { WarehouseCompResponse } from '../../Models/warehouseModel';
import { Observable } from 'rxjs';
import { NamedResponse } from '../models/shared.model';
import { Apps } from '../enums/enums';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  baseCompanyMangUrl: string = environment.companyApiBaseUrl;
  baseListerUrl: string = environment.listerApiBaseUrl;
  baseImsUrl: string = environment.imsApiBaseUrl;
  constructor(private http: HttpClient) {}

  getUserRoleDetails(userId: number): Observable<UserRolesModel[]> {
    const url = `${this.baseCompanyMangUrl}/Users/${userId}/Roles`;
    return this.http.get<UserRolesModel[]>(url);
  }

  getUserDetails(userId: number) {
    const url = `${this.baseCompanyMangUrl}/Users/${userId}`;
    return this.http.get<UserModel>(url);
  }

  getWarehouses(
    companyId: number | undefined
  ): Observable<WarehouseCompResponse[]> {
    const url = `${this.baseImsUrl}/Warehouses?CompanyId=${companyId}`;
    return this.http.get<WarehouseCompResponse[]>(url);
  }

  getWareHouseLocations(companyId: number, warehouseId: number) {
    const url = `${this.baseImsUrl}/WarehouseLocations?CompanyId=${companyId}&WarehouseId=${warehouseId}`;
    return this.http.get(url);
  }

  setDefaultWarehouse(
    userId: number,
    warehouseId: number,
    warehouseLocationId: number | null,
    isDefault: boolean
  ) {
    const url = `${this.baseCompanyMangUrl}/Users/${userId}/Warehouses/${warehouseId}/Default`;
    return this.http.put(url, {
      app: Apps.Lister,
      listerDefaultWarehouseLocationId: warehouseLocationId,
      isDefault: isDefault,
    });
  }

  getUsersLite(companyId: number) {
    const url = `${this.baseListerUrl}/Users?CompanyId=${companyId}`;
    return this.http.get<NamedResponse[]>(url);
  }
}
